import { useQuery } from 'react-query';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

export type Props = {
  ticketId?: number;
};

function useGetTicketDetailById({ ticketId }: Props) {
  const { ticket: ticketApi } = useApiContext();
  const { showApiError } = useGlobalContext();

  const { data: ticket, isLoading } = useQuery(
    [KEYS.ticket.tickets.detail(ticketId), ticketId],
    () => ticketApi.tickets.detail(ticketId),
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
      enabled: !!ticketId,
      onError: (error) =>
        showApiError(error, 'Error al cargar el detalle del ticket')
    }
  );

  return {
    ticket,
    isTicketDetailLoading: isLoading
  };
}

export default useGetTicketDetailById;
